import React, { useState } from 'react';
import imageCompression from 'browser-image-compression';

interface PhotoUploaderProps {
  onUpload: (photoURL: string) => void;
}

export const PhotoUploader: React.FC<PhotoUploaderProps> = ({ onUpload }) => {
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);
      
      // For now, convert to base64 as a placeholder for actual storage upload
      const reader = new FileReader();
      reader.onloadend = () => {
        onUpload(reader.result as string);
        setIsUploading(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error('Error compressing image:', error);
      setIsUploading(false);
    }
  };

  return (
    <div className="mt-2 font-mono">
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={isUploading}
        className="terminal-input text-xs p-1 rounded-sm w-full file:mr-4 file:py-1 file:px-2 file:rounded-sm file:border-0 file:text-xs file:font-semibold file:bg-amber-900/30 file:text-amber-500 hover:file:bg-amber-900/50"
      />
      {isUploading && <p className="text-xs text-amber-500 mt-1">Compressing...</p>}
    </div>
  );
};
